import React from "react";
import { Outlet } from "react-router-dom";
import ZoneScene from "@/components/ZoneScene";

/**
 * QuadLayout — renders the persistent Campus Quad scene with a nested
 * <Outlet />. Locked-area routes (e.g. /studio, /merch) render the
 * Under Construction modal into the Outlet without dismounting the
 * WebGL canvas — keeping interaction snappy and avoiding context-loss.
 */
export default function QuadLayout() {
  return (
    <div data-testid="campus-quad-page" style={{ width: "100%", height: "100vh", background: "#0b1530" }}>
      <ZoneScene initialMode="orbit" />
      <Outlet />
    </div>
  );
}
